function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.229 20.026h4.649c2.733 0 4.474-1.441 4.474-3.647a3.061 3.061 0 0 0-3.093-3.079v-.079a2.747 2.747 0 0 0 2.514-2.733c0-1.986-1.529-3.2-4.034-3.2h-4.51a1.45 1.45 0 0 0-1.582 1.594v9.554a1.45 1.45 0 0 0 1.582 1.59zm1.608-7.479V9.471h1.89c1.2 0 1.907.554 1.907 1.494 0 .984-.782 1.582-2.1 1.582zm0 5.326v-3.428h1.951c1.485 0 2.32.6 2.32 1.7 0 1.125-.765 1.731-2.232 1.731z",
  transform: "translate(-8.647 -7.291)"
});

function SvgBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.705,
    height: 12.735,
    viewBox: "0 0 10.705 12.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.840b501d.svg";
export { ForwardRef as ReactComponent };